var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "150",
        height: "121",
        viewBox: "0 0 150 121",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M68.5421 7.42596L75.3914 20.5772H145.884C147.909 20.5772 149.551 22.2186 149.551 24.2439V116.822C149.551 118.846 147.91 120.488 145.884 120.488H10.6845C8.65978 120.488 7.01782 118.847 7.01782 116.822V27.4514V20.5766V9.11887C7.01782 7.09418 8.65913 5.45288 10.6845 5.45288H65.2902C66.6572 5.45288 67.9105 6.21311 68.5421 7.42596Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M67.6551 7.88783C67.1958 7.00571 66.2843 6.45288 65.2902 6.45288H10.6845C9.2113 6.45288 8.01782 7.64659 8.01782 9.11887V116.822C8.01782 118.294 9.21195 119.488 10.6845 119.488H145.884C147.357 119.488 148.551 118.294 148.551 116.822V24.2439C148.551 22.771 147.357 21.5772 145.884 21.5772H74.7847L67.6551 7.88783ZM75.3914 20.5772L68.5421 7.42596C67.9105 6.21311 66.6572 5.45288 65.2902 5.45288H10.6845C8.65913 5.45288 7.01782 7.09418 7.01782 9.11887V116.822C7.01782 118.847 8.65978 120.488 10.6845 120.488H145.884C147.91 120.488 149.551 118.846 149.551 116.822V24.2439C149.551 22.2186 147.909 20.5772 145.884 20.5772H75.3914Z",
          fill: "#8796AF",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M18.7295 37.0486C28.8255 37.0486 37.0098 28.8643 37.0098 18.7683C37.0098 8.67241 28.8255 0.488037 18.7295 0.488037C8.63358 0.488037 0.449219 8.67241 0.449219 18.7683C0.449219 28.8643 8.63358 37.0486 18.7295 37.0486Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M80.9089 81.7242C72.7235 80.6983 63.0015 84.2272 54.4401 96.2741L52.8099 95.1155C61.7054 82.5986 72.0958 78.604 81.1576 79.7397C90.1478 80.8664 97.6347 87.0298 100.766 94.4349L98.9243 95.2139C96.0605 88.4423 89.1657 82.759 80.9089 81.7242Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M55.2511 74.7644C58.7411 74.7644 61.5703 69.6375 61.5703 63.313C61.5703 56.9886 58.7411 51.8616 55.2511 51.8616C51.7611 51.8616 48.9319 56.9886 48.9319 63.313C48.9319 69.6375 51.7611 74.7644 55.2511 74.7644Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M58.8439 70.9272C59.8913 69.0292 60.5703 66.3391 60.5703 63.313C60.5703 60.287 59.8913 57.5968 58.8439 55.6988C57.777 53.7654 56.4645 52.8616 55.2511 52.8616C54.0376 52.8616 52.7251 53.7654 51.6583 55.6988C50.6109 57.5968 49.9319 60.287 49.9319 63.313C49.9319 66.3391 50.6109 69.0292 51.6583 70.9272C52.7251 72.8606 54.0376 73.7644 55.2511 73.7644C56.4645 73.7644 57.777 72.8606 58.8439 70.9272ZM61.5703 63.313C61.5703 69.6375 58.7411 74.7644 55.2511 74.7644C51.7611 74.7644 48.9319 69.6375 48.9319 63.313C48.9319 56.9886 51.7611 51.8616 55.2511 51.8616C58.7411 51.8616 61.5703 56.9886 61.5703 63.313Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M107.791 63.3128C107.791 69.6368 104.961 74.7642 101.472 74.7642C97.9814 74.7642 95.1526 69.6375 95.1526 63.3128C95.1526 60.5517 95.6917 58.0191 96.5899 56.0413C97.7488 53.4889 99.5056 51.8621 101.472 51.8621C104.962 51.8614 107.791 56.9882 107.791 63.3128Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M97.5005 56.4548L97.5004 56.4549C96.6689 58.2857 96.1526 60.6743 96.1526 63.3128C96.1526 66.339 96.8315 69.0291 97.8788 70.9271C98.9456 72.8604 100.258 73.7642 101.472 73.7642C102.685 73.7642 103.998 72.8603 105.064 70.9269C106.112 69.0287 106.791 66.3386 106.791 63.3128C106.791 60.2866 106.112 57.5965 105.065 55.6986C103.998 53.7654 102.686 52.8618 101.472 52.8621L101.472 52.8621C100.103 52.8621 98.6036 54.025 97.5005 56.4548ZM101.472 51.8621C99.5056 51.8621 97.7488 53.4889 96.5899 56.0413C95.6917 58.0191 95.1526 60.5517 95.1526 63.3128C95.1526 69.6375 97.9814 74.7642 101.472 74.7642C104.961 74.7642 107.791 69.6368 107.791 63.3128C107.791 56.9882 104.962 51.8614 101.472 51.8621Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M101.105 45.8641C106.003 40.4657 109.951 40.3426 111.224 48.7743L101.105 45.8641Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M101.105 45.8641L111.224 48.7743C111.166 48.3918 111.103 48.0269 111.035 47.6793C109.671 40.773 106.199 40.6959 101.88 45.0464C101.624 45.3036 101.366 45.5764 101.105 45.8641ZM102.984 45.364L109.947 47.3664C109.666 46.1211 109.318 45.1805 108.928 44.5012C108.398 43.5786 107.843 43.2155 107.33 43.1139C106.786 43.0061 106.05 43.1434 105.083 43.7161C104.438 44.0979 103.736 44.6476 102.984 45.364Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M57.4637 42.0799C52.5654 36.6815 48.6174 36.5584 47.3442 44.9901L57.4637 42.0799Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M47.3442 44.9901L57.4637 42.0799C57.2026 41.7922 56.9443 41.5195 56.6889 41.2622C52.3696 36.9117 48.897 36.9888 47.5339 43.8951C47.4653 44.2427 47.402 44.6076 47.3442 44.9901ZM55.5845 41.5798C54.8327 40.8634 54.1302 40.3137 53.4855 39.9319C52.5186 39.3592 51.7829 39.2219 51.2389 39.3297C50.7257 39.4313 50.1706 39.7945 49.6409 40.717C49.2509 41.3964 48.902 42.3369 48.6218 43.5822L55.5845 41.5798Z",
          fill: "#222222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M18.7296 26.9165C17.408 26.9114 16.2708 26.5862 15.3181 25.9407C14.3705 25.2953 13.6405 24.3605 13.1283 23.1363C12.6212 21.912 12.3702 20.4394 12.3753 18.7183C12.3753 17.0023 12.6289 15.5399 13.136 14.331C13.6482 13.1221 14.3781 12.2027 15.3258 11.5726C16.2785 10.9375 17.4131 10.6199 18.7296 10.6199C20.046 10.6199 21.178 10.9375 22.1257 11.5726C23.0784 12.2078 23.8109 13.1298 24.3231 14.3387C24.8354 15.5424 25.0889 17.0023 25.0838 18.7183C25.0838 20.4445 24.8277 21.9197 24.3155 23.144C23.8083 24.3682 23.081 25.303 22.1333 25.9484C21.1857 26.5938 20.0511 26.9165 18.7296 26.9165ZM18.7296 24.1582C19.6311 24.1582 20.3508 23.7048 20.8886 22.7982C21.4265 21.8915 21.6928 20.5316 21.6877 18.7183C21.6877 17.5248 21.5648 16.531 21.3189 15.7371C21.0781 14.9431 20.735 14.3464 20.2893 13.9468C19.8488 13.5473 19.3289 13.3475 18.7296 13.3475C17.8332 13.3475 17.116 13.7957 16.5782 14.6921C16.0403 15.5885 15.7689 16.9306 15.7637 18.7183C15.7637 19.9271 15.8841 20.9362 16.1249 21.7456C16.3707 22.5498 16.7165 23.1542 17.1621 23.5589C17.6078 23.9584 18.1302 24.1582 18.7296 24.1582Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }